<template>
<footer class="page-footer">
  <!-- Content wrapper only to combine `.container` and `--sidebar-width` margin. -->
  <div class="page-footer__content static-container">
    <div class="page-footer__primary">
      <div class="page-footer__logo">
        <img :src="footerLogo" alt="">
      </div>
      <div class="page-footer__sections">
        <section
          v-if="hasMainMenuLinks"
          class="page-footer__section page-footer__section-info"
        >
          <h5 class="page-footer__section-header">Информация</h5>
          <ul class="page-footer__section-info-links">
            <!-- <router-link
              :to="{ name: '' }"
            >Акции</router-link> -->
            <li
              v-for="mainMenuLink in footerMenuLinks"
            >
              <router-link :to="mainMenuLink.to">{{ mainMenuLink.text }}</router-link>
            </li>
            <!-- <router-link>Бонусная программа</router-link>
            <router-link>Вакансии</router-link>
            <router-link>Отзывы</router-link> -->
          </ul>
        </section>
        <section
          v-if="displayPhone || displaySchedule || displayAddress"
          class="page-footer__section page-footer__section-order"
        >
          <h5 class="page-footer__section-header">Сделать заказ</h5>
          <div
            v-if="displayPhone"
            class="page-footer__section-order-item"
          >
            <div class="page-footer__section-order-item-icon">
              <i class="fas fa-phone" style="transform: scale(-1, 1);"/>
            </div>
            <div class="page-footer__section-order-item-text">
              <a
                :href="`tel:${phone.e164}`"
                class="page-footer__section-order-item-text-main"
              >{{ phone.national }}</a>
              <p
                v-if="schedule"
                class="page-footer__section-order-item-text-sub"
              >
                <template v-if="schedule.today.open">
                  <span class="inline-block rounded-full bg-success" style="width: 6px; height: 6px;"/>
                  <span> Работаем сейчас</span>
                </template>
                <template v-else>Откроемся {{ schedule.today.next_open_at.short }}</template>
              </p>
            </div>
          </div>
          <button
            v-if="displaySchedule"
            class="page-footer__section-order-item"
            style="text-align: inherit;"
            v-tippy="tippyProps"
          >
            <div class="page-footer__section-order-item-icon">
              <i class="fas fa-clock"/>
            </div>
            <div class="page-footer__section-order-item-text">
              <p
                class="page-footer__section-order-item-text-main"
              >{{ scheduleStr }}</p>
              <p class="page-footer__section-order-item-text-sub">Сегодня</p>
            </div>

            <div style="display: none;">
              <table data-tippy-content>
                <tbody class="align-baseline">
                  <tr
                    v-for="day of (scheduleDaysArr || [])"
                    :key="day.day"
                  >
                    <td class="p-1">{{ day.name }}</td>
                    <td class="p-1">
                      <template v-if="day.hours.length > 0">
                        <!-- eslint-disable-next-line vue/require-v-for-key -->
                        <span
                          v-for="period of day.hours"
                          class="block"
                        >{{ period }}</span>
                      </template>
                      <template v-else>Выходной</template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </button>
          <div
            v-if="displayAddress"
            class="page-footer__section-order-item"
          >
            <div class="page-footer__section-order-item-icon">
              <i class="fas fa-map-marker-alt"/>
            </div>
            <div class="page-footer__section-order-item-text">
              <p class="page-footer__section-order-item-text-sub" style="color: inherit;">{{ address }}</p>
            </div>
          </div>
        </section>
        <div
          v-if="displaySocials || displayOnlinePayments"
          class="page-footer__vertical-section-group"
        >
          <section
            v-if="displaySocials"
            class="page-footer__section"
          >
            <h5 class="page-footer__section-header">Следите за нами</h5>
            <!-- Copy-pasted from `sidebars/Base.vue`. -->
            <!-- eslint-disable-next-line vue/require-v-for-key -->
            <a
              v-for="social of socials"
              :href="social.value"
              target="_blank"
              rel="noreferrer nofollow noopener"
              class="page-footer__social-link"
            >
              <i class="fab" :class="`fa-${social.type.id}`"/>
            </a>
            <div id="zenky-footer-banners"></div>
          </section>
          <section
            v-if="displayOnlinePayments"
            class="page-footer__section"
          >
            <h5 class="page-footer__section-header">Онлайн оплата</h5>
            <ul class="page-footer__payment-systems-list">
              <li><img :src="require('@/assets/images/icons/footer/payment-systems/visa.svg')" alt="Visa"></li>
              <li><img :src="require('@/assets/images/icons/footer/payment-systems/mc.svg')" alt="Master Card"></li>
              <li><img :src="require('@/assets/images/icons/footer/payment-systems/mir.svg')" alt="Мир"></li>
            </ul>
          </section>
        </div>
        <section
          v-if="$store.getters['store/hasNativeApps']"
          class="page-footer__section"
        >
          <h5 class="page-footer__section-header">Скачать приложение</h5>
          <NativeAppLinks/>
        </section>
      </div>
    </div>
    <div class="page-footer__secondary">
      <p>© {{ (new Date()).getFullYear() }} {{ $store.state.store.store && $store.state.store.store.name }}</p>
      <router-link v-if="legalDocs.privacy_policy" :to="{ name: 'legal-privacy-policy' }">Политика конфиденциальности</router-link>
      <router-link v-if="legalDocs.personal_data" :to="{ name: 'legal-personal-data-policy' }">Политика обработки персональных данных</router-link>
      <router-link v-if="legalDocs.personal_data_agreement" :to="{ name: 'legal-personal-data-agreement' }">Согласие на обработку персональных данных</router-link>
      <router-link v-if="legalDocs.eula" :to="{ name: 'legal-eula' }">Пользовательское соглашение</router-link>
      <router-link v-if="legalDocs.terms" :to="{ name: 'legal-terms' }">Публичная оферта</router-link>
      <div class="flex-grow" style="margin: 0;"></div>
      <a v-if="shouldDisplayCopyright" href="https://zenky.io">Работает на платформе «Zenky Business»</a>
    </div>
  </div>
</footer>
</template>

<script>
import { mapGetters } from 'vuex'
import addressToString from '@/helpers/addressToString';
import scheduleDaysToArray from '@/helpers/scheduleDaysToArray';
import scheduleObjToString from '@/helpers/scheduleObjToString';
import HasMainMenuLinks from "@/mixins/HasMainMenuLinks";

export default {
  directives: {
    tippy: {
      async bind(el, binding, vnode) {
        const styleP = import(/* webpackPreload: true */ 'tippy.js/dist/tippy.css');
        const tippy = (await import(/* webpackPreload: true */ 'tippy.js')).default;
        await styleP;

        if (el.tippyUnbound) {
          return;
        }

        tippy(el, binding.value);
      },
      unbind(el) {
        el._tippy?.destroy();
        el.tippyUnbound = true;
      }
    },
  },
  components: {
    NativeAppLinks: () => import('@/components/NativeAppLinks'),
  },
  mixins: [HasMainMenuLinks],
  computed: {
    ...mapGetters({
      activeCity: 'store/activeCity',
      socials: 'store/activeCitySocials',
      footerLogo: 'settings/footerLogo',
      store: 'store/store',
      legalDocs: 'settings/legalDocs',
    }),

    phone() {
      // May not be present.
      return this.$store.getters['store/activeCityPhone'];
    },

    schedule() {
      return this.activeCity?.schedule;
    },

    scheduleDaysArr() {
      if (!this.schedule) return null;
      return scheduleDaysToArray(this.schedule.days);
    },

    scheduleStr() {
      return this.schedule && 'с ' + scheduleObjToString(this.schedule, ' до ');
    },

    tippyProps() {
      return {
        content: trigger => trigger.querySelector('[data-tippy-content]'),
        allowHTML: true,
      };
    },

    address() {
      const firstStockWithAddress = this.activeCity?.stocks.find(stock => !!stock.address?.id)
      if (!firstStockWithAddress) {
        return null;
      }
      return addressToString(firstStockWithAddress.address);
    },

    displayPhone() {
      return !!this.phone;
    },

    displaySchedule() {
      return !!this.schedule;
    },

    displayAddress() {
      return !!this.address;
    },

    displaySocials() {
      return this.socials?.length > 0;
    },

    displayOnlinePayments() {
      return this.$store.getters['store/supportsOnlineCardPayments'];
    },

    shouldDisplayCopyright() {
      if (this.store?.settings?.website?.copyright_enabled === undefined) {
        return true;
      }

      return this.store?.settings?.website?.copyright_enabled;
    },
  },
}
</script>

<style lang="less">
@r: page-footer;

@default-font-size: theme('fontSize.sm');
@default-line-height: theme('lineHeight.tight');
@logo-padding-x: theme('padding.6');
@section-padding-x: theme('padding.3');

.@{r} {
  margin-left: var(--sidebar-width);
  line-height: @default-line-height;
  font-size: @default-font-size;
  @apply border-t bg-footer-bg text-footer-text-normal;
  &__primary {
    @apply flex;
    @py: theme('padding.5');
    padding: @py @section-padding-x;
  }
  &__logo {
    @apply hidden;
  }
  &__sections {
    @apply flex-grow;

    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(theme('width.48'), 1fr));
  }
  &__horizontal-section-group {
    @apply flex flex-wrap;
  }
  &__vertical-section-group {
    @apply flex flex-col; // So margins don't collapse.
  }
  &__section {
    @apply my-3 mx-3;
  }
  &__section-header {
    @apply text-footer-text-lighter font-bold mb-6;
  }

  &__section-info-links {
    > * {
      @apply my-2;
    }
  }

  &__section-order-item {
    @apply flex my-3;
  }
  @section-order-item-icon-size: calc(theme('width.8') - theme('width.1'));
  &__section-order-item-icon {
    height: @section-order-item-icon-size;
    width: @section-order-item-icon-size;
    @apply bg-primary-lightest text-primary flex items-center justify-center rounded-full mr-2;
    flex: 0 0 auto;
  }
  &__section-order-item-text {
    @font-size: @default-font-size;
    @line-height: @default-line-height;
    // So it's centered with the icon.
    margin-top: calc((@section-order-item-icon-size - @font-size * @line-height) / 2);
  }
  &__section-order-item-text-main {
    @apply block font-bold;
  }
  &__section-order-item-text-sub {
    @apply text-footer-text-lighter text-xs;
  }

  &__social-link {
    @apply text-2xl mr-4 leading-none;
  }

  &__payment-systems-list {
    @mx: calc(theme('margin.4') / 2);
    @my: calc(theme('margin.3') / 2);
    @apply flex flex-wrap items-center;
    margin: calc(-1 * @my) calc(-1 * @mx);
    > * {
      margin: @my @mx;
    }
  }

  &__secondary {
    @apply border-t text-footer-text-lighter text-xs px-6 py-2 flex flex-wrap;
    > * {
      @apply my-2;
      &:not(:last-child) {
        @apply mr-4;
      }
    }
  }
}

@screen xl {
  .@{r} {
    &__logo {
      @apply block;
      padding: 0 @logo-padding-x;
      max-width: calc(theme('width.64') + @logo-padding-x);
      flex: 0 0 auto;
    }
    &__sections {
      justify-items: center;
    }
    &__secondary {
      padding-right: calc(@section-padding-x + @logo-padding-x);
      padding-left: calc(@section-padding-x + @logo-padding-x);
    }
  }
}
</style>
